export const COLOR_IMPORTED = 'secondary';
export const COLOR_PROCESSED = 'success';
export const COLOR_BILLABLE = 'secondary';
export const COLOR_BILLED = 'success';
export const COLOR_REJECTED = 'default';
export const COLOR_REPLACED = 'error';
export const COLOR_SENT = 'accent';